import { createFileRoute } from '@tanstack/react-router';
import { Button } from '@/components/atoms/button';
import { FormPageLayout } from '@/components/layouts';
import { CompanyProfileFormPanel } from '@/components/organisms/settings-company/CompanyProfileFormPanel';
import { useHasPermission } from '@/hooks/usePermissions';

const SECTION_KEYS = ['address', 'branding'] as const;

type CompanyProfileSectionKey = (typeof SECTION_KEYS)[number];

interface CompanyEditSearch {
  section?: CompanyProfileSectionKey;
}

export const Route = createFileRoute('/_dashboard/dashboard/settings/company/edit')({
  validateSearch: (search: Record<string, unknown>): CompanyEditSearch => ({
    section: SECTION_KEYS.includes(search.section as CompanyProfileSectionKey)
      ? (search.section as CompanyProfileSectionKey)
      : undefined,
  }),
  component: EditCompanySettingsPage,
});

function EditCompanySettingsPage() {
  const navigate = Route.useNavigate();
  const { section } = Route.useSearch();
  const canEdit = useHasPermission('company:edit');

  function goBack() {
    void navigate({ to: '/dashboard/settings/company' });
  }

  if (!canEdit) {
    return (
      <FormPageLayout
        title="Edit Company Profile"
        onBack={goBack}
        maxWidth="2xl"
        actions={
          <Button type="button" variant="outline" size="sm" onClick={goBack}>
            Back
          </Button>
        }
      >
        <div className="rounded-lg border bg-background p-6 text-sm text-muted-foreground">
          You do not have permission to edit the company profile.
        </div>
      </FormPageLayout>
    );
  }

  return <CompanyProfileFormPanel onCancel={goBack} onSaved={goBack} initialSection={section} />;
}
